import{ORG_LIST_FAIL, ORG_LIST_REQUEST, ORG_LIST_SUCCESS, PROTONDX_ADMIN_DATA_EXPORT_FAIL, PROTONDX_ADMIN_DATA_EXPORT_REQUEST, PROTONDX_ADMIN_DATA_EXPORT_SUCCESS, PROTONDX_ADMIN_INFECTION_STATS_FAIL, PROTONDX_ADMIN_INFECTION_STATS_REQUEST, PROTONDX_ADMIN_INFECTION_STATS_SUCCESS, PROTONDX_ADMIN_MANAGE_ORG_FAIL, PROTONDX_ADMIN_MANAGE_ORG_REQUEST, PROTONDX_ADMIN_MANAGE_ORG_SUCCESS,
    PROTONDX_ADMIN_RESET_CSV_JSON,
    PROTONDX_ADMIN_STATS_FAIL,
    PROTONDX_ADMIN_STATS_REQUEST,
    PROTONDX_ADMIN_STATS_SUCCESS,
    PROTONDX_ADMIN_MANAGE_ORG_RESET, PROTONDX_ADMIN_GET_SAMPLEIDS_REQUEST, PROTONDX_ADMIN_GET_SAMPLEIDS_SUCCESS, PROTONDX_ADMIN_GET_SAMPLEIDS_FAIL,
    PROTONDX_ADMIN_ADD_SAMPLEID_REQUEST,PROTONDX_ADMIN_ADD_SAMPLEID_SUCCESS,PROTONDX_ADMIN_ADD_SAMPLEID_FAIL,
    PROTONDX_ADMIN_UPDATE_SAMPLEID_REQUEST,PROTONDX_ADMIN_UPDATE_SAMPLEID_SUCCESS,PROTONDX_ADMIN_UPDATE_SAMPLEID_FAIL,
    PROTONDX_ADMIN_DELETE_SAMPLEID_REQUEST,PROTONDX_ADMIN_DELETE_SAMPLEID_SUCCESS,PROTONDX_ADMIN_DELETE_SAMPLEID_FAIL,
    PROTONDX_ADMIN_GET_TESTPANELS_REQUEST, PROTONDX_ADMIN_GET_TESTPANELS_SUCCESS, PROTONDX_ADMIN_GET_TESTPANELS_FAIL,
    PROTONDX_ADMIN_ADD_TESTPANELID_REQUEST,PROTONDX_ADMIN_ADD_TESTPANELID_SUCCESS,PROTONDX_ADMIN_ADD_TESTPANELID_FAIL,
    PROTONDX_ADMIN_UPDATE_TESTPANELID_REQUEST,PROTONDX_ADMIN_UPDATE_TESTPANELID_SUCCESS,PROTONDX_ADMIN_UPDATE_TESTPANELID_FAIL,
    PROTONDX_ADMIN_DELETE_TESTPANELID_REQUEST,PROTONDX_ADMIN_DELETE_TESTPANELID_SUCCESS,PROTONDX_ADMIN_DELETE_TESTPANELID_FAIL
} from '../types'


export const protondxAdminStatsReducer = (state={},action) =>{
    switch(action.type){
        case PROTONDX_ADMIN_STATS_REQUEST:
            return{
                processing:true,
            }

        case PROTONDX_ADMIN_STATS_SUCCESS:
            return{
                processing:false,
                stats:action.stats,
                barGraphData:action.bar_graph_data,
                pievalues: action.pie_values,
                colorScale: action.colorScale
            }

        case PROTONDX_ADMIN_STATS_FAIL:
            return{
                processing:false,
                error:action.payload
            }
        default:
            return state
    }
}

export const protondxAdminInfectionStatsReducer = (state={},action) =>{
    switch(action.type){
        case PROTONDX_ADMIN_INFECTION_STATS_REQUEST:
            return{
                processing:true,
            }

        case PROTONDX_ADMIN_INFECTION_STATS_SUCCESS:
            return{
                processing:false,
                infectionStats:action.payload
            }

        case PROTONDX_ADMIN_INFECTION_STATS_FAIL:
            return{
                processing:false,
                error:action.payload
            }
        default:
            return state
    }
}

export const protondxAdminOrgListReducer = (state={},action) =>{
    switch(action.type){
        case ORG_LIST_REQUEST:
            return{
                fetching_org_list:true,
            }

        case ORG_LIST_SUCCESS:
            return{
                fetching_org_list:false,
                orgs: action.payload,
                orgoptions:action.options
            }

        case ORG_LIST_FAIL:
            return{
                fetching_org_list:false,
                error:action.payload
            }
        default:
            return state
    }
}

export const protondxAdminExportDataReducer = (state={},action) =>{
    switch(action.type){
        case PROTONDX_ADMIN_DATA_EXPORT_REQUEST:
            return{
                exporting:true,
            }

        case PROTONDX_ADMIN_DATA_EXPORT_SUCCESS:
            return{
                exporting:false,
                exportable_json:action.payload,
                export_data_received:action.data_received
            }

        case PROTONDX_ADMIN_RESET_CSV_JSON:
            return{
                exporting:false,
                exportable_json:[],
                export_data_received:false
            }
        case PROTONDX_ADMIN_DATA_EXPORT_FAIL:
            return{
                exporting:false,
                error:action.payload,

            }
        default:
            return state
    }
}


export const protondxAdminManageOrgReducer = (state={},action) =>{
    switch(action.type){
        case PROTONDX_ADMIN_MANAGE_ORG_REQUEST:
            return{
                processing:true,
            }

        case PROTONDX_ADMIN_MANAGE_ORG_SUCCESS:
            return{
                processing:false,
                success: action.payload
            }

        case PROTONDX_ADMIN_MANAGE_ORG_FAIL:
            return{
                processing:false,
                error:"Email is incorrect/ used."
            }
        case PROTONDX_ADMIN_MANAGE_ORG_RESET:
            return{
                processing:false,
                success:false
            }
        default:
            return state
    }
}

export const protondxAdminSampleIdsReducer = (state={},action) =>{
    switch(action.type){
        case PROTONDX_ADMIN_GET_SAMPLEIDS_REQUEST:
            return{
                processing:true,
            }

        case PROTONDX_ADMIN_GET_SAMPLEIDS_SUCCESS:
            return{
                processing:false,
                success: action.payload
            }

        case PROTONDX_ADMIN_GET_SAMPLEIDS_FAIL:
            return{
                processing:false,
                error:"Unable to get Sample IDs"
            }
        default:
            return state
    }
}

export const protondxAdminAddSampleIdReducer = (state={},action) =>{
    switch(action.type){
        case PROTONDX_ADMIN_ADD_SAMPLEID_REQUEST:
            return{
                processing:true,
                success: false,
                error: false
            }

        case PROTONDX_ADMIN_ADD_SAMPLEID_SUCCESS:
            return{
                processing:false,
                success: action.payload,
                error: false
            }

        case PROTONDX_ADMIN_ADD_SAMPLEID_FAIL:
            return{
                processing:false,
                success: false,
                error:"Unable to add Sample ID"
            }
        default:
            return state
    }
}

export const protondxAdminUpdateSampleIdReducer = (state={processing2:false,
                success2: null,
                error2: false} ,action) =>{
    switch(action.type){
        case PROTONDX_ADMIN_UPDATE_SAMPLEID_REQUEST:
            return{
              ...state,
                processing2:true,
                success2: null,
                error2: false
            }

        case PROTONDX_ADMIN_UPDATE_SAMPLEID_SUCCESS:
            return{
              ...state,
                processing2:false,
                success2: action.payload,
                error2: false
            }

        case PROTONDX_ADMIN_UPDATE_SAMPLEID_FAIL:
            return{
              ...state,
                processing2:false,
                success2: null,
                error2:"Unable to update Sample ID"
            }
        default:
            return state
    }
}

export const protondxAdminDeleteSampleIdReducer = (state={},action) =>{
    switch(action.type){
        case PROTONDX_ADMIN_DELETE_SAMPLEID_REQUEST:
            return{
                ...state,
                processing3:true,
            }

        case PROTONDX_ADMIN_DELETE_SAMPLEID_SUCCESS:
            return{
              ...state,
                processing3:false,
                success3: action.payload
            }

        case PROTONDX_ADMIN_DELETE_SAMPLEID_FAIL:
            return{
              ...state,
                processing3:false,
                error3:"Unable to delete Sample ID"
            }
        default:
            return state
    }
}


export const protondxAdminTestPanelIdsReducer = (state={},action) =>{
    switch(action.type){
        case PROTONDX_ADMIN_GET_TESTPANELS_REQUEST:
            return{
                processing1:true,
            }

        case PROTONDX_ADMIN_GET_TESTPANELS_SUCCESS:
            return{
                processing1:false,
                success1: action.payload
            }

        case PROTONDX_ADMIN_GET_TESTPANELS_FAIL:
            return{
                processing1:false,
                error1:"Unable to get Sample IDs"
            }
        default:
            return state
    }
}

export const protondxAdminAddTestPanelIdReducer = (state={},action) =>{
    switch(action.type){
        case PROTONDX_ADMIN_ADD_TESTPANELID_REQUEST:
            return{
                processing:true,
                success: false,
                error: false
            }

        case PROTONDX_ADMIN_ADD_TESTPANELID_SUCCESS:
            return{
                processing:false,
                success: action.payload,
                error: false
            }

        case PROTONDX_ADMIN_ADD_TESTPANELID_FAIL:
            return{
                processing:false,
                success: false,
                error:"Unable to add Sample ID"
            }
        default:
            return state
    }
}

export const protondxAdminUpdateTestPanelIdReducer = (state={},action) =>{
    switch(action.type){
        case PROTONDX_ADMIN_UPDATE_TESTPANELID_REQUEST:
            return{
                processing2:true,
            }

        case PROTONDX_ADMIN_UPDATE_TESTPANELID_SUCCESS:
            return{
                processing2:false,
                success2: action.payload
            }

        case PROTONDX_ADMIN_UPDATE_TESTPANELID_FAIL:
            return{
                processing2:false,
                error2:"Unable to update Sample ID"
            }
        default:
            return state
    }
}

export const protondxAdminDeleteTestPanelIdReducer = (state={},action) =>{
    switch(action.type){
        case PROTONDX_ADMIN_DELETE_TESTPANELID_REQUEST:
            return{
                ...state,
                processing3:true,
            }

        case PROTONDX_ADMIN_DELETE_TESTPANELID_SUCCESS:
            return{
              ...state,
                processing3:false,
                success3: action.payload
            }

        case PROTONDX_ADMIN_DELETE_TESTPANELID_FAIL:
            return{
              ...state,
                processing3:false,
                error3:"Unable to delete Sample ID"
            }
        default:
            return state
    }
}
